/* eslint-disable jsx-a11y/anchor-is-valid */
import Header from "../pages/header";
import Footer from "../pages/footer";
import React, { useState, useRef, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { createJobs } from "../../services/jobs";
import { categories, jobsTypes } from "../data/job_data";

const CreateJob = () => {
  const [inputs, setInputs] = useState({});
  // const [createdJob, setCreatedJob] = useState({});
  const [getError, setErrors] = useState({ message: "", type: "" });
  const messageRef = useRef(null);

  useEffect(() => {
    if (getError.message && messageRef.current) {
      messageRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center", // Scrolls so the element is in the center of the view
      });
    }
  }, [getError]);

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    console.log("Submitting job with data:", inputs);
    const resposne = await createJobs(inputs);
    debugger;
    if (resposne.status) {
      if (resposne.status === 500) {
        setErrors({ message: resposne.statusText, type: "error" });
      } else {
        setErrors({ message: "Job Created Successfully!", type: "success" });
        setInputs({});
      }
    } else {
      setErrors({ message: "Something Went Wrong!", type: "error" });
    }
  };

  const handleResponsibilityChange = (value) => {
    // We manually update the 'responsibility' field in your state
    setInputs((prev) => ({ ...prev, responsibility: value }));
  };

  const handleQualificationsChange = (value) => {
    // We manually update the 'qualifications' field in your state
    setInputs((prev) => ({ ...prev, qualifications: value }));
  };

  const handleDescriptionChange = (value) => {
    // We manually update the 'description' field in your state
    setInputs((prev) => ({ ...prev, description: value }));
  };

  return (
    <div>
      <div className="container-fluid bg-white p-0">
        <Header path="job_details"></Header>
        <div className="container-fluid py-5 bg-dark page-header mb-5">
          <div className="container my-5 pt-5 pb-4">
            <h1 className="display-3 text-white mb-3 animated slideInDown">
              Create Jobs
            </h1>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb text-uppercase">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                {/* <li className="breadcrumb-item">
                  <a href="#">Pages</a>
                </li> */}
                <li
                  className="breadcrumb-item text-white active"
                  aria-current="page"
                >
                  Create Job
                </li>
              </ol>
            </nav>
          </div>
        </div>
        {/* Header End */}
        {/* Job Detail Start */}
        <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
          <div className="container">
            <div className="row gy-5 gx-4">
              <div className="col-lg-8">
                <div
                  ref={messageRef}
                  className={`breadcrumb-item ${
                    getError.type === "success" ? "text-success" : "text-danger"
                  }`}
                >
                  {getError.message}
                </div>
                <div className>
                  <h4 className="mb-4">Create Job</h4>
                  <form onSubmit={handleSubmit}>
                    <div className="row g-3">
                      <div className="col-12 col-sm-6">
                        <select
                          defaultValue={inputs.category || ""}
                          className="form-control"
                          name="category"
                          onChange={handleChange}
                        >
                          {/* Default placeholder option */}
                          <option value="">Select Job Category</option>

                          {/* Dynamic mapping of categories */}
                          {categories.map((category) => (
                            <option key={category.id} value={category.label}>
                              {category.label}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-12 col-sm-6">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Job Title"
                          name="title"
                          value={inputs.title || ""}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-12 col-sm-6">
                        <select
                          defaultValue={inputs.category || ""}
                          className="form-control"
                          placeholder="Job Type"
                          name="job_type"
                          onChange={handleChange}
                        >
                          <option value="N/A">Select Job Type</option>
                          {jobsTypes.map((type) => (
                            <option key={type.id} value={type.label}>
                              {type.label}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-12 col-sm-6">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Role"
                          name="role"
                          value={inputs.role || ""}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-12 col-sm-6">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Job Location"
                          name="location"
                          value={inputs.location || ""}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-12 col-sm-6">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Job Salary"
                          name="salary"
                          value={inputs.salary || ""}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-12 col-sm-6">
                        <label className="form-label fw-bold">
                          Company Logo
                        </label>
                        <input
                          type="file"
                          className="form-control bg-white"
                          name="company_logo"
                          value={inputs.company_logo || ""}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-12">
                        <label className="form-label">Job Responsibility</label>
                        <ReactQuill
                          theme="snow"
                          value={inputs.responsibility || ""}
                          onChange={handleResponsibilityChange}
                          placeholder="Job Responsibility..."
                          className="bg-white" // Bootstrap class to ensure background is white
                          style={{ height: "200px", marginBottom: "50px" }} // Editors need explicit height
                        />
                      </div>
                      <div className="col-12">
                        <label className="form-label">Job Qualifications</label>
                        <ReactQuill
                          theme="snow"
                          value={inputs.qualifications || ""}
                          onChange={handleQualificationsChange}
                          placeholder="Job Qualifications..."
                          className="bg-white" // Bootstrap class to ensure background is white
                          style={{ height: "200px", marginBottom: "50px" }} // Editors need explicit height
                        />
                      </div>

                      <div className="col-12">
                        <label className="form-label">Job Description</label>
                        <ReactQuill
                          theme="snow"
                          value={inputs.description || ""}
                          onChange={handleDescriptionChange}
                          placeholder="Job Description ..."
                          className="bg-white" // Bootstrap class to ensure background is white
                          style={{ height: "200px", marginBottom: "50px" }} // Editors need explicit height
                        />
                      </div>
                      <div className="col-12">
                        <button className="btn btn-primary w-100" type="submit">
                          Create Job
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="col-lg-4">
                <div
                  className="bg-light rounded p-5 mb-4 wow slideInUp"
                  data-wow-delay="0.1s"
                >
                  <h4 className="mb-4">Job Summery</h4>
                  <p>
                    <i className="fa fa-angle-right text-primary me-2" />
                    Published On: 01 Jan, 2045
                  </p>
                  <p>
                    <i className="fa fa-angle-right text-primary me-2" />
                    Vacancy: 123 Position
                  </p>
                  <p>
                    <i className="fa fa-angle-right text-primary me-2" />
                    Job Nature: Full Time
                  </p>
                  <p>
                    <i className="fa fa-angle-right text-primary me-2" />
                    Salary: $123 - $456
                  </p>
                  <p>
                    <i className="fa fa-angle-right text-primary me-2" />
                    Location: New York, USA
                  </p>
                  <p className="m-0">
                    <i className="fa fa-angle-right text-primary me-2" />
                    Date Line: 01 Jan, 2045
                  </p>
                </div>
                <div
                  className="bg-light rounded p-5 wow slideInUp"
                  data-wow-delay="0.1s"
                >
                  <h4 className="mb-4">Company Detail</h4>
                  <p className="m-0">
                    Our Company is a leading IT industry/sectors.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Job Detail End */}
        {/* Footer Start */}
        <Footer></Footer>
        {/* Footer End */}
        {/* Back to Top */}
        <a
          href="#"
          className="btn btn-lg btn-primary btn-lg-square back-to-top"
        >
          <i className="bi bi-arrow-up" />
        </a>
      </div>
      {/* JavaScript Libraries */}
      {/* Job Portal Website Javascript */}
    </div>
  );
};

export default CreateJob;
